module.exports = __webpack_public_path__ + "static/media/footerlogo1.de45ec4a.png";